<div class="nb-wrap">
  <!-- Chip: Modo Reunión / No Molestar activo (clic para reactivar) -->
  <button
    type="button"
    class="nb-dnd-chip"
    *ngIf="isDndActive$ | async"
    (click)="clearDnd($event)"
    [title]="(dndLabel$ | async) + ' · Clic para reactivar las alertas'"
  >
    <fa-icon [icon]="faMoon"></fa-icon>
    <span>{{ dndShortLabel$ | async }}</span>
  </button>

  <button
    type="button"
    class="nb-bell"
    data-tour="bell"
    [class.nb-bell--muted]="isDndActive$ | async"
    (click)="toggle($event)"
    aria-label="Notificaciones"
    title="Notificaciones"
  >
    <fa-icon [icon]="(isDndActive$ | async) ? faBellSlash : faBell"></fa-icon>
    <span class="nb-badge" *ngIf="(unreadCount$ | async) as count" [class.nb-badge--zero]="count === 0">
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>

  <div class="nb-dropdown" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="nb-dropdown__head">
      <span class="nb-dropdown__title">Notificaciones</span>
      <button
        type="button"
        class="nb-mark"
        (click)="markAllRead()"
        [disabled]="(unreadCount$ | async) === 0"
      >
        Marcar todas como leídas
      </button>
    </div>

    <!-- Modo Reunión / No Molestar (Snooze) -->
    <div class="nb-dnd">
      <div class="nb-dnd__title">
        <fa-icon [icon]="faMoon"></fa-icon>
        <span>Modo Reunión / No molestar</span>
      </div>
      <p class="nb-dnd__hint">Silencia recordatorios y avisos mientras estás en una llamada o presentación.</p>

      <ng-container *ngIf="!(isDndActive$ | async); else dndActive">
        <div class="nb-dnd__options">
          <button
            type="button"
            class="nb-dnd__opt"
            *ngFor="let opt of dndOptions"
            (click)="snooze(opt.mode, $event)"
            [title]="opt.hint"
          >
            {{ opt.label }}
          </button>
        </div>
      </ng-container>
      <ng-template #dndActive>
        <div class="nb-dnd__active">
          <span class="nb-dnd__active-label">
            <fa-icon [icon]="faBellSlash"></fa-icon>
            {{ dndLabel$ | async }}
          </span>
          <button type="button" class="nb-dnd__reactivate" (click)="clearDnd($event)">Reactivar ahora</button>
        </div>
      </ng-template>
    </div>

    <div class="nb-list" *ngIf="items$ | async as items">
      <button
        type="button"
        class="nb-item"
        *ngFor="let n of items"
        [class.nb-item--unread]="!n.readAt"
        (click)="onItemClick(n)"
      >
        <span class="nb-item__title">{{ n.title }}</span>
        <span class="nb-item__body" *ngIf="n.body">{{ n.body }}</span>
        <span class="nb-item__date">{{ n.createdAt | date: 'dd/MM · HH:mm' }}</span>
      </button>

      <p class="nb-empty" *ngIf="items.length === 0">No tienes notificaciones.</p>
    </div>

    <button type="button" class="nb-all" (click)="openAll()">Ver todas las notificaciones</button>
  </div>
</div>

<!-- Toast temporal ante eventos en vivo -->
<div class="nb-toast" *ngIf="toast as t">
  <span class="nb-toast__icon">🔔</span>
  <span class="nb-toast__content">
    <strong class="nb-toast__title">{{ t.title }}</strong>
    <small class="nb-toast__body" *ngIf="t.body">{{ t.body }}</small>
  </span>
</div>
